<template>
    <div class="main-item item" :class="{ cancelled: item.isCancelled }">
        <div class="head">
            <div class="quantity">
                <span v-if="item.cancelledQuantity > 0" class="cancelled"> {{ item.originalTotalQuantity }}x </span>
                <span v-if="item.currentTotalQuantity > 0"> {{ item.currentTotalQuantity }}x </span>
            </div>
            <div class="main-name name">{{ itemName }}<ItemIcons v-if="item.articleId" :articleId="item.articleId" /></div>
            <div v-if="displayPrice" class="price">{{ unitPrice }}</div>
        </div>

        <div v-if="item.options.length" class="subs">
            <OptionGroup
                v-for="optionGroup in item.options"
                :key="optionGroup.id"
                :optionGroup="optionGroup"
                :isParentItemCancelled="item.isCancelled"
                :displayPrice="displayPrice"
            />
        </div>
        <div class="comment" v-if="item.comment">
            {{ item.comment.text }}
        </div>
    </div>
</template>

<script setup lang="ts">
    import type { IOrderItem } from "@/data/model/Order";
    import { getNameInLocationLanguage } from "@/shared/helpers/ItemNameHelper";
    import { toMoney } from "@/shared/utils/format";
    import { computed } from "vue";

    import ItemIcons from "@/components/order/ItemIcons.vue";

    import OptionGroup from "@/operator/components/order/OptionGroup.vue";

    const props = defineProps<{
        item: IOrderItem;
        displayPrice: boolean;
    }>();

    const itemName = computed(() => getNameInLocationLanguage(props.item, true));

    const unitPrice = computed(() => {
        if (props.item.unitPrice === 0) return "";

        return toMoney(props.item.isCancelled ? props.item.originalTotalAmount : props.item.currentTotalAmount, true);
    });
</script>

<style lang="scss"></style>
